import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  marginTop: "20px",
  borderRadius: "10px",
  overflow: "auto",
  '& .MuiTableCell-head': {
    backgroundColor: "#647490",
    color: "white",
    fontWeight: "bold"
  }
}));

const DeletedItemsTable = ({ items, onRecover }) => {
  return (
    <StyledTableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Recently Deleted Items</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="right">Recover</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items && items.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.name}</TableCell>
              <TableCell align="center">{item.date}</TableCell>
              <TableCell align="right">
                <img 
                  src="/path/to/recover-icon.svg" 
                  alt="Recover" 
                  style={{ cursor: 'pointer' }}
                  onClick={() => onRecover(item)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableContainer>
  );
};

export default DeletedItemsTable;